import { render, staticRenderFns } from "./Proben.vue?vue&type=template&id=f14a3792&scoped=true&"
import script from "./Proben.vue?vue&type=script&lang=js&"
export * from "./Proben.vue?vue&type=script&lang=js&"
import style0 from "./Proben.vue?vue&type=style&index=0&id=f14a3792&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f14a3792",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDivider,VImg,VRow})
